module.exports = __webpack_public_path__ + "static/317932249_666023378527434_6870253941256497314_n.jpg-1671186392485_512-9bbc76d8d933ebd487df069e2bd1cb4e.webp";